const EMPTY_DENSITY = '—';

/** Display-only request density in kg/m³, rounded to one decimal. */
export function formatRequestDensity(weight: number | null, volume: number | null): string {
  if (
    weight === null ||
    volume === null ||
    !Number.isFinite(weight) ||
    !Number.isFinite(volume) ||
    weight <= 0 ||
    volume <= 0
  ) {
    return EMPTY_DENSITY;
  }
  return (weight / volume).toFixed(1);
}
